import { useEffect } from "react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { flushQueue, getQueue } from "@/lib/attQueue";

const label = (it) => (it.type === "scan" ? "QR" : it.type === "paid" ? "pago" : `asistencia de ${it.label || "un alumno"}`);

async function sync() {
  const pending = getQueue().length;
  if (!pending) return;
  const { sent, failed } = await flushQueue();
  if (sent) toast.success(`Conexión recuperada: se guardaron ${sent} marca(s) de asistencia/pago hechas sin señal.`);
  failed.forEach((f) => toast.error(`No se pudo registrar ${label(f)}: ${typeof f.reason === "string" ? f.reason : "revisa la lista"}`));
}

// Envía las marcas hechas sin señal apenas vuelve la conexión (o al abrir la app).
export function AttendanceSync() {
  const { user } = useAuth();
  const active = user?.role === "business";
  useEffect(() => {
    if (!active) return undefined;
    sync();
    const t = setInterval(sync, 30000);
    window.addEventListener("online", sync);
    return () => { clearInterval(t); window.removeEventListener("online", sync); };
  }, [active]);
  return null;
}
